import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        this.toggleOptionWrapper();
        this.selectTargets.forEach((el) => el.addEventListener("change", () => this.toggleOptionWrapper()));
        this.radioTargets.forEach((radio) => {
            radio.addEventListener("change", () => this.displayMessageDiv());
        });
    }
    toggleOptionWrapper() {
        if (!this.hasOptionWrapperTarget)
            return;
        // Find the checkbox for "trailed_implement"
        const trailedCheckbox = this.selectTargets.find((el) => el.id === "subject_classifications__trailed_implement");
        if (trailedCheckbox?.checked) {
            this.optionWrapperTarget?.classList.remove("d-none");
            this.optionWrapperTarget?.classList.add("bg-warning", "highlight-appear");
            setTimeout(() => {
                this.optionWrapperTarget?.classList.remove("bg-warning");
            }, 1000);
        }
        else {
            this.optionWrapperTarget?.classList.add("d-none");
        }
    }
    displayMessageDiv() {
        const radios = this.radioTargets;
        const groups = {};
        radios.forEach((r) => {
            var _a;
            groups[_a = r.name] || (groups[_a] = []);
            groups[r.name].push(r);
        });
        const anyLastChecked = Object.values(groups).some((group) => {
            const lastRadio = group[group.length - 1];
            return lastRadio.checked;
        });
        if (anyLastChecked) {
            this.messageDivTarget.classList.remove("d-none");
        }
        else {
            this.messageDivTarget.classList.add("d-none");
        }
    }
}
default_1.targets = ["select", "radio", "optionWrapper", "messageDiv"];
export default default_1;
